<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div
    v-cloak
    class="d-flex  align-center justify-center flex-column"
    style="height: 100%;position: relative"
  >
    <div
      style="width: 70%;max-width: 480px;"
    >
      <template v-if="!checkDeviceId">
        <template v-if="!isLoading">
          <o-t-p-keyboard

            :title="title"
            @submit="checkStorePinCode"
          />
        </template>
        <template v-else>
          <div class="d-flex justify-center align-center flex-column">
            <div class="mb-10 text-h4">
              {{ $t('waitAMoment') }}
            </div>
            <v-progress-circular
              indeterminate
              size="64"
            />
          </div>
        </template>
      </template>
      <template v-else>
        <div
          class="mt-8"
        >
          <product-card
            v-for="item in productList"
            :key="item.id"
            :checked="selectedProductCode.includes(item.metadata.code)"
            :desc="item.description"
            :name="item.name"
            :one-time="item.realPrice.type"
            :price="item.realPrice.unit_amount/100"
            @clickCard="toggle(item.metadata.code)"
          />
        </div>
        <div class="d-flex align-center justify-center">
          <div
            class="mt-4"
          >
            <v-btn
              color="blue lighten-5 black--text"
              elevation="0"
              large
              @click="back"
            >
              <v-icon left>
                mdi-arrow-left
              </v-icon>
              <slot>
                {{ $t('ToReturn') }}
              </slot>
            </v-btn>
          </div>
          <next-step-button
            class="ml-4"
            @next="nextStep"
          >
            {{ $t('BuyNow') }}
          </next-step-button>
        </div>
      </template>
      <div
        class="d-flex flex-column align-center text-caption text--secondary"
        style="width: 100%;position: absolute;left: 0;right: 0;bottom: 48px;"
      >
        <div>
          Aaden POS v {{ version }}
        </div>
        <div>
          Copyright 2023, InnerKen All Rights Reserved.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OTPKeyboard from '@/views/widget/PINInput/OTPKeyboard.vue'
import { decodeDeviceId, getInfoForDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import NextStepButton from '@/views/SaaS/widget/NextStepButton'
import { addProduct, getCurrentSaaSOrderInfo, resetOrder } from '@/views/SaaS/SaaSGuide'
import ProductCard from '@/views/SaaS/widget/ProductCard'
import { createUserRelationShip } from '@/model/dataLayer/api/SaaS/subscriptionService'

export default {
  name: 'FirstOwnStore',
  components: {
    ProductCard,
    NextStepButton,
    OTPKeyboard
  },
  data () {
    return {
      timeZone: true,
      selectedProductCode: [],
      currentStoreId: null,
      productList: [],
      checkDeviceId: false,
      isLoading: false,
      title: this.$t('EnterAadenActivationPin'),
      version: require('../../../package.json').version
    }
  },
  computed: {
    realSelectedList () {
      return this.productList.filter(it => this.selectedProductCode.includes(it.metadata.code))
    }
  },
  methods: {
    back () {
      this.checkDeviceId = false
    },
    nextStep () {
      this.realSelectedList.forEach(it => {
        addProduct(it)
      })
      getCurrentSaaSOrderInfo().storeId = this.currentStoreId
      this.$router.push({ name: 'order-confirmation' })
    },
    toggle (code) {
      if (this.selectedProductCode.includes(code)) {
        this.selectedProductCode = this.selectedProductCode.filter(it => it !== code)
      } else {
        this.selectedProductCode.push(code)
        this.selectedProductCode = this.selectedProductCode.filter(it => it === code)
      }
    },
    async login (deviceId) {
      this.isLoading = true
      resetOrder()
      // const allProducts = await loadProducts()
      // const shouldShowCode = [ProductCodes.extraStore]
      // shouldShowCode.push(ProductCodes.oldDevice)
      // this.selectedProductCode.push(ProductCodes.oldDevice)
      // this.productList = allProducts.filter(it => shouldShowCode.includes(it.metadata.code))
      // await saveTemporaryStoreId(deviceId)
      // this.checkDeviceId = true
      await createUserRelationShip(deviceId)
      this.isLoading = false
      await this.$router.push('/login')
      location.reload()
    },
    async checkStorePinCode (code) {
      this.isLoading = true
      const outId = decodeDeviceId(code).toString()
      this.currentStoreId = outId
      const res = await getInfoForDeviceId(outId)
      this.isLoading = false
      if (res.broken) {
        this.title = this.$t('PleaseEnterRightAadenActivationPin')
      } else {
        await this.login(outId)
      }
    }
  }
}
</script>

<style scoped>

</style>
